var _excluded = ["size", "textAlign", "isSticky", "onKeyDown"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { forwardRef } from '../../../../../utils';
import { useStyleConfig } from '../../../../../utils/use-style-config';
import { Box } from '../../../Box';
import { _useCellSize as useCellSize } from '../../_useCellSize';
/**
 * @private This is for internal use only.
 */

import { jsx as _jsx } from "react/jsx-runtime";
export var _TableDataCell = forwardRef((_ref, propRef) => {
  var {
    size,
    textAlign,
    isSticky,
    onKeyDown
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var ref = useRef(null);
  useImperativeHandle(propRef, () => ref.current);
  var [offsetLeft, setOffsetLeft] = useState(0);
  var [offsetTop, setOffsetTop] = useState(0);
  useEffect(() => {
    var _ref$current$offsetLe, _ref$current, _ref$current$offsetTo, _ref$current2;

    setOffsetLeft((_ref$current$offsetLe = (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.offsetLeft) !== null && _ref$current$offsetLe !== void 0 ? _ref$current$offsetLe : 0);
    setOffsetTop((_ref$current$offsetTo = (_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.offsetTop) !== null && _ref$current$offsetTo !== void 0 ? _ref$current$offsetTo : 0);
  }, []);
  var style = useStyleConfig('_TableDataCell', {
    size: useCellSize(size),
    textAlign,
    isSticky,
    left: offsetLeft,
    top: offsetTop
  });

  var handleKeyDown = event => {
    // We need to stop propagation even if the event didn't occur from the cell.
    // This is required in key down as opposed to click event for the following example:
    // The whole row is clickable, so the mouse click can occur on specific cells and need to propagate to hit the row.
    // When talking about keyboard navigation - there's a tab on the whole row in case it's clickable, and only then the key down should be done on the row.
    // Otherwise, the event should be done on the focused element (say it is a button in a cell in the row).
    event.stopPropagation();
    onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
  };

  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    role: "cell",
    __css: style,
    "data-component": "TableDataCell"
  }, props), {}, {
    ref: ref,
    onKeyDown: handleKeyDown
  }));
});
_TableDataCell.displayName = 'TableDataCell';
//# sourceMappingURL=_TableDataCell.js.map